import React from "react";
import { Heading, HeadingProps } from "@tennr/frontend/components/Heading";
import { HubspotForm, HubspotFormProps } from "@tennr/frontend/components/BookDemoForm";
import "./FormHeroSection.css";

export type FormHeroSectionProps = {
  heading: HeadingProps;
  hubspotForm: HubspotFormProps;
}
export const FormHeroSection: React.FC = (props: FormHeroSectionProps) => {
  return (
    <section className="form-hero-section">
      <div className="form-hero-section-content">
        <Heading
        {...props?.heading}
        />
        <HubspotForm {...props?.hubspotForm} />
      </div>
    </section>
  );
};
